<template>
	<div class="common-layout">
		<el-container direction="vertical">
			<el-header class="fixed-top" :class="{ 'layout-header--compact': isCompactNav }">
				<el-menu v-if="!isCompactNav" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
					:ellipsis="false" @select="handleSelect" background-color="#ffffff" text-color="#000000"
					active-text-color="#044591">

					<el-menu-item index="/" class="navbar-brand" style="border-bottom: none">
						<img src="/img/logo1.png" alt="LOGO" class="img-fluid" />
					</el-menu-item>
					<el-menu-item
						v-for="item in menu"
						:key="(item.menuIndex || item.to) + item.name"
						:index="item.menuIndex != null ? item.menuIndex : item.to"
					>{{ item.name }}</el-menu-item>
				</el-menu>
				<div v-else class="layout-mobile-bar">
					
					<router-link to="/dashboard/index" class="layout-mobile-brand" @click="onMobileLogoClick">
						<img src="/img/logo1.png" alt="LOGO" class="layout-mobile-brand-img" />
					</router-link>
					<el-button class="layout-mobile-menu-btn" text aria-label="打开导航菜单" @click="mobileMenuOpen = true">
						<el-icon :size="26">
							<Menu />
						</el-icon>
					</el-button>
				</div>
			</el-header>
			<el-drawer
				v-if="isCompactNav"
				v-model="mobileMenuOpen"
				direction="rtl"
				:size="mobileDrawerSize"
				class="layout-nav-drawer"
				:show-close="false"
				modal-class="layout-nav-drawer-modal"
				append-to-body
			>
				<template #header>
					<div class="layout-nav-drawer__head">
						<span class="layout-nav-drawer__title">网站导航</span>
						<button
							type="button"
							class="layout-nav-drawer__close"
							aria-label="关闭导航"
							@click.stop="mobileMenuOpen = false"
						>
							<el-icon :size="20"><Close /></el-icon>
						</button>
					</div>
				</template>
				<nav class="layout-mobile-nav" aria-label="网站导航">
					<router-link
						v-for="item in menu"
						:key="'m-' + (item.menuIndex || item.to) + item.name"
						:to="resolveMobileRoute(item)"
						class="layout-mobile-nav__item"
						:class="{
							'is-active': isMobileNavActive(item),
						}"
						@click.stop="onMobileNavClick(item, $event)"
					>
						<span class="layout-mobile-nav__label">{{ item.name }}</span>
					</router-link>
				</nav>
			</el-drawer>
			<router-view />
			<el-footer class="layout-footer">
				<div class="footer bg-green layout-footer-inner">
					<div class="footerDiv">
						<img src="/img/logo1.png" alt="LOGO" class="img-fluid footer-logo" />

						<div class="footer-address">
							地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：郑州市金水区农业路经五路国际企业中心B座2901<br />
							电子邮箱：149899506@qq.com
						</div>

						<ul class="links">
							<li>
								<router-link to="/dashboard/about" @click="onFooterLinkClick('/dashboard/about', $event)"> 关于文博 </router-link>
							</li>
							<li>
								<router-link to="/dashboard/contact" @click="onFooterLinkClick('/dashboard/contact', $event)">  联系我们 </router-link>
							</li>
							<!-- <li>
								<router-link to="/"> 法律信息 </router-link>
							</li> -->
						</ul>

						<div class="footer-copy">
							河南文博建设工程有限公司&nbsp;&nbsp;&nbsp;&nbsp;
							<a href="https://beian.miit.gov.cn" target="_blank">豫ICP备17016779号-1</a>
							ALL Rights Reserved. Copyright 2007-2019
						</div>
					</div>
					<div class="phone">
						<div class="mobile">
							<img src="/img/phone.png" alt="" />
							<div>
								<span class="footer-hotline-label">全国服务热线</span><br />
								<span class="footer-hotline-num">
									15517577700<br />
									13083690099
								</span>
							</div>
						</div>
						<div class="code">
							<div>
								<img src="@/style/img/code.png" alt="CODE" />
								更多信息请添加<br />
								微信咨询
							</div>
						</div>
					</div>
				</div>
			</el-footer>
		</el-container>
	</div>
</template>

<script>
import { getTypeTheme, getTypeSustainability } from "@/api/home";
import {
	INDEX_HOME_ANCHOR_MAP,
	scrollPageToTop,
	scrollToHashTarget,
	scrollToIndexHash,
	scrollWindowToTop,
	getWindowScrollTop,
} from "@/utils/routeScroll";

import { mapGetters } from "vuex";
export default {
	data() {
		return {
			width: 990,
			viewportWidth: typeof window !== "undefined" ? window.innerWidth : 1200,
			mobileMenuOpen: false,
			navIndex: -1,
			isPC: true,
			isShow: true,
			scrollPosition: 0,
			activeIndex: "/",
			menu: [
				{
					name: "首页",
					to: "/",
				},
				{
					name: "关于文博",
					to: "/dashboard/about",
				},
				{
					name: "典型案例",
					to: "/dashboard/products",
				},
				{
					name: "业务范围",
					to: '/dashboard/business'
				},
				{
					name: "建筑移位",
					to: "/dashboard/relocation",
				},
				{
					name: "项目过程",
					to: "/",
					// 与「首页」区分，避免 el-menu 两个项同为 index "/"
					menuIndex: "/#life-aeolus",
				},
				{
					name: "公司动态",
					to: "/dashboard/newsroom",
				},
				{
					name: "联系我们",
					to: "/dashboard/contact",
				},
			],
		};
	},
	mounted() {
		this.syncViewport();
		this.bindScrollTracking();
		window.addEventListener("resize", this.handleResize, { passive: true });
	},
	computed: {
		...mapGetters(["num", "childnum", "childnum1"]),
		isCompactNav() {
			return this.viewportWidth < 992;
		},
		mobileDrawerSize() {
			const vw = typeof window !== "undefined" ? window.innerWidth : 375;
			return `${Math.min(vw * 0.72, 264)}px`;
		},
	},
	watch: {
		num: {
			immediate: true,
			handler(val) {
				if (val === undefined || val === null || val === "") {
					return;
				}
				this.activeIndex = val;
			},
		},
	},
	methods: {
		handleSelect(e) {
			if (!e) {
				return;
			}

			const indexAnchorId = INDEX_HOME_ANCHOR_MAP[e];
			// PC 在首页时：菜单项滚到对应区块，不跳子页面
			if (indexAnchorId && this.$route.name === "index") {
				this.activeIndex = e;
				this.$store.commit("SET_NUM", e);
				if (this.isCompactNav) {
					this.mobileMenuOpen = false;
				}
				scrollToIndexHash(`#${indexAnchorId}`, this.$router);
				return;
			}

			// 「项目过程」→ 首页 #life-aeolus
			if (e === "/#life-aeolus") {
				this.activeIndex = e;
				this.$store.commit("SET_NUM", e);
				if (this.isCompactNav) {
					this.mobileMenuOpen = false;
				}
				scrollToIndexHash("#life-aeolus", this.$router);
				return;
			}

			this.activeIndex = e;
			this.$store.commit("SET_NUM", e);
			if (this.isCompactNav) {
				this.mobileMenuOpen = false;
			}
			const path = e === "/" ? "/dashboard/index" : e;
			this.$router.push(path).catch(() => {});
		},
		scrollToAnchor(id, retries = 12, interval = 80) {
			return scrollToHashTarget(`#${id}`, { retries, interval, behavior: "smooth" });
		},
		goToLifeAeolusAnchor() {
			scrollToIndexHash("#life-aeolus", this.$router);
		},
		onFooterLinkClick(path, event) {
			this.activeIndex = path;
			this.$store.commit("SET_NUM", path);

			if (this.$route.path === path && !this.$route.hash) {
				event.preventDefault();
				scrollPageToTop({ behavior: "auto", retries: 8 });
				return;
			}

			// 从长页面（如首页底部）跳转时先回顶，避免新页面沿用底部滚动位置
			scrollWindowToTop("auto");
		},
		onMobileLogoClick(event) {
			this.activeIndex = "/";
			this.$store.commit("SET_NUM", "/");
			this.mobileMenuOpen = false;
			if (this.$route.path === "/dashboard/index" && !this.$route.hash) {
				if (event) {
					event.preventDefault();
				}
				scrollPageToTop({ behavior: "smooth", retries: 4 });
				return;
			}
			if (event) {
				event.preventDefault();
			}
			this.$router.push({ path: "/dashboard/index", hash: "" }).catch(() => {});
		},
		getMenuIndex(item) {
			return item.menuIndex != null ? item.menuIndex : item.to;
		},
		isMobileNavActive(item) {
			return this.activeIndex === this.getMenuIndex(item);
		},
		resolveMobileRoute(item) {
			const index = this.getMenuIndex(item);
			if (index === "/") {
				return { path: "/dashboard/index", hash: "" };
			}
			if (index === "/#life-aeolus") {
				return { name: "index", hash: "#life-aeolus" };
			}
			if (typeof index === "string" && index.startsWith("/dashboard/")) {
				return { path: index, hash: "" };
			}
			return index;
		},
		onMobileNavClick(item, event) {
			const index = this.getMenuIndex(item);
			if (!index) {
				return;
			}

			this.activeIndex = index;
			this.$store.commit("SET_NUM", index);
			this.mobileMenuOpen = false;

			// 「项目过程」：手机端跳转首页并滚动到 #life-aeolus
			if (index === "/#life-aeolus") {
				event.preventDefault();
				this.goToLifeAeolusAnchor();
				return;
			}

			// 首页：清除 hash 并回到顶部
			if (index === "/") {
				event.preventDefault();
				if (this.$route.path === "/dashboard/index" && !this.$route.hash) {
					scrollPageToTop({ behavior: "smooth", retries: 4 });
				} else {
					this.$router.push({ path: "/dashboard/index", hash: "" }).catch(() => {});
				}
				return;
			}

			// 关于文博等子页：已在当前页则回顶部
			if (index === "/dashboard/about") {
				if (this.$route.path === "/dashboard/about" && !this.$route.hash) {
					event.preventDefault();
					scrollPageToTop({ behavior: "smooth", retries: 4 });
					return;
				}
			}

			const target = this.resolveMobileRoute(item);
			const current = this.$route;
			let isSameRoute = false;
			if (typeof target === "string") {
				isSameRoute = current.path === target && !current.hash;
			} else if (target.path) {
				isSameRoute =
					current.path === target.path &&
					(target.hash ? current.hash === target.hash : !current.hash);
			} else if (target.name) {
				isSameRoute =
					current.name === target.name &&
					(target.hash ? current.hash === target.hash : !current.hash);
			}

			if (isSameRoute) {
				event.preventDefault();
				scrollPageToTop({ behavior: "smooth", retries: 4 });
			}
		},

		async getTypeTheme() {
			const data = await getTypeTheme();

			if (data.code == 0) {
				if (data.data.length > 0) {
					let arr = data.data.map((item) => {
						let obj = {
							name: item.label,
							to: "/dashboard/newsroom/star-products",
							description: item.description,
						};

						return obj;
					});
					this.menu[3].children = arr;

					this.$store.commit("SET_THEMELIST", arr);
				}
			}
		},
		syncViewport() {
			const w = window.innerWidth;
			this.viewportWidth = w;
			this.width = w;
			if (w < 992) {
				this.isShow = false;
				this.isPC = false;
			} else {
				this.isShow = true;
				this.isPC = true;
				this.mobileMenuOpen = false;
			}
		},
		handleResize() {
			this.syncViewport();
		},
		changeTab() {
			this.isShow = !this.isShow;
		},
		incrementCount() {
			this.$store.commit("SET_NUM", -1);
		},
		menuToActive() { },
		bindScrollTracking() {
			if (typeof window === "undefined") {
				return;
			}

			this._onScrollTrack = (event) => {
				if (this._scrollTrackRaf) {
					return;
				}
				this._scrollTrackRaf = requestAnimationFrame(() => {
					this._scrollTrackRaf = null;
					let top = getWindowScrollTop();
					const target = event && event.target;
					if (target instanceof Element && target !== document.documentElement && target !== document.body) {
						top = Math.max(top, target.scrollTop || 0);
					}
					this.scrollPosition = Math.round(top);
				});
			};

			this._onScrollTrack();
			const opts = { passive: true, capture: true };
			window.addEventListener("scroll", this._onScrollTrack, opts);
			document.addEventListener("scroll", this._onScrollTrack, opts);
			document.addEventListener("touchmove", this._onScrollTrack, opts);
			document.addEventListener("touchend", this._onScrollTrack, opts);
		},
		unbindScrollTracking() {
			if (!this._onScrollTrack || typeof window === "undefined") {
				return;
			}
			const opts = { passive: true, capture: true };
			window.removeEventListener("scroll", this._onScrollTrack, opts);
			document.removeEventListener("scroll", this._onScrollTrack, opts);
			document.removeEventListener("touchmove", this._onScrollTrack, opts);
			document.removeEventListener("touchend", this._onScrollTrack, opts);
			if (this._scrollTrackRaf) {
				cancelAnimationFrame(this._scrollTrackRaf);
				this._scrollTrackRaf = null;
			}
			this._onScrollTrack = null;
		},
		navFun1(index, index1) {
			this.$store.commit("SET_NUM", index);
			this.$store.commit("SET_CHILDNUM", index1);

			if (this.menu[index].name == "Newsroom") {
				this.$store.commit("SET_THEMEITEM", this.menu[index].children[index1]);
			}
			if (!this.isPC) {
				this.isShow = false;
			}
		},
		navFun2(index, index1, index2) {
			this.$store.commit("SET_NUM", index);
			this.$store.commit("SET_CHILDNUM", index1);

			this.$store.commit("SET_CHILDNUM1", index2);

			if (!this.isPC) {
				this.isShow = false;
			}
		},
		navFun(item, index) {
			if (!item.children) {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", -1);
				if (!this.isPC) {
					this.isShow = false;
				}
				return;
			}
			if (item.to == item.children[0].to) {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", 0);
			} else {
				this.$store.commit("SET_NUM", index);
				this.$store.commit("SET_CHILDNUM", -1);
			}
			if (!this.isPC) {
				this.isShow = false;
			}
		},
	},
	beforeUnmount() {
		this.unbindScrollTracking();
		window.removeEventListener("resize", this.handleResize);
	},
};
</script>

<style lang="less">
.layout-footer.el-footer {
	height: auto !important;
	padding: 0 !important;
	box-sizing: border-box;
}

.layout-footer-inner {
	position: relative;
	min-height: 13rem;
}

.bg-green {
	background-color: #e9e9e9;
	color: rgba(0, 0, 0, 0.8);
}

.footerDiv {
	padding-left: 22.5rem;
	display: flex;
	flex-direction: column;
	font-size: 1.1rem;
	font-family: SourceHanSansCN-Regular;
	font-weight: normal;
	color: rgba(0, 0, 0, 0.8);
	padding-top: 2.2rem;
}

.footer-logo {
	width: 33.3125rem;
	max-width: 100%;
	height: auto;
	display: block;
}

.footer-address {
	padding-top: 0.5rem;
	line-height: 2.3rem;
}

.footer-copy {
	padding-top: 0.9rem;
	padding-bottom: 3.4rem;
}

.footer .links {
	padding-top: 1rem;
	padding-left: 0;
	margin-bottom: 0;
	font-size: 1.125rem;
	margin-left: -1.125rem;
}

.footer .links li {
	list-style: none;
	display: inline-block;
}

.footer .links li {
	height: 1rem;
	padding: 0 1.125rem;
	border-right: 1px solid #535353;
	line-height: 1rem;
}

.footer a {
	color: rgba(0, 0, 0, 0.8);
	text-decoration: none;
}
.footer a:hover{
	color: rgb(253, 1, 1);
	text-decoration: none;
}
.footer .links li:last-child {
	border-right: none;
}

.footer-hotline-label {
	display: inline-block;
}

.footer-hotline-num {
	font-family: 'SourceHanSansCN-Bold', 'Microsoft YaHei', sans-serif;
	font-size: 2.8rem;
	line-height: 1.15;
}

.layout-header--compact.el-header {
	height: auto !important;
	min-height: 3.5rem;
	padding: 0 0.75rem !important;
	box-sizing: border-box;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}

.layout-mobile-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	min-height: 3.5rem;
}

.layout-mobile-brand {
	display: flex;
	align-items: center;
	border-bottom: none;
	text-decoration: none;
}

.layout-mobile-brand-img {
	display: block;
	width: min(52vw, 17rem);
	height: auto;
	object-fit: contain;
}

.layout-mobile-menu-btn {
	padding: 0.5rem !important;
	margin-right: -0.25rem;
	color: #044591 !important;
	min-width: 2.75rem;
	min-height: 2.75rem;
}

.layout-nav-drawer.el-drawer {
	.el-drawer__header {
		margin-bottom: 0;
		padding: 0;
		border-bottom: 1px solid #ebebeb;
	}

	.el-drawer__body {
		padding: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
}

.layout-nav-drawer__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 0.85rem 1rem 0.85rem 1.15rem;
	box-sizing: border-box;
}

.layout-nav-drawer__title {
	font-size: 1.05rem;
	font-weight: 600;
	color: #044591;
	letter-spacing: 0.04rem;
}

.layout-nav-drawer__close {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2.25rem;
	height: 2.25rem;
	margin: 0;
	padding: 0;
	border: none;
	border-radius: 50%;
	background: transparent;
	color: rgba(0, 0, 0, 0.55);
	cursor: pointer;
	transition: background-color 0.2s ease, color 0.2s ease;

	&:hover,
	&:focus-visible {
		background-color: rgba(0, 0, 0, 0.06);
		color: #044591;
		outline: none;
	}
}

.layout-mobile-nav {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0.35rem 0 0.5rem;
	box-sizing: border-box;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}

.layout-mobile-nav__item {
	display: flex;
	align-items: center;
	width: 100%;
	margin: 0;
	padding: 0.72rem 1.15rem;
	border: none;
	border-bottom: 1px solid #f2f2f2;
	border-left: 3px solid transparent;
	background: #fff;
	color: rgba(0, 0, 0, 0.88);
	font-family: inherit;
	font-size: 0.98rem;
	line-height: 1.35;
	text-align: left;
	text-decoration: none;
	cursor: pointer;
	box-sizing: border-box;
	touch-action: manipulation;
	-webkit-tap-highlight-color: transparent;
	transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

	&:last-child {
		border-bottom: none;
	}

	&:active {
		background-color: #f5f8fc;
	}

	&.is-active {
		color: #044591;
		font-weight: 600;
		background-color: #f0f6fc;
		border-left-color: #044591;
	}

	&:focus-visible {
		outline: 2px solid rgba(4, 69, 145, 0.35);
		outline-offset: -2px;
	}
}

.layout-mobile-nav__label {
	flex: 1;
	min-width: 0;
}

.phone {
	width: 44.1rem;
	height: 13.8rem;
	background-color: #00499f;
	position: absolute;
	top: -5.56rem;
	right: 0;

	.mobile {
		display: flex;
		font-family: SourceHanSansCN-Regular;
		font-size: 1.5rem;
		line-height: 2.9rem;
		margin: 2.5rem 3rem 0;
		color: #fff;

		img {
			width: 4.688rem;
			height: 4.688rem;
			margin-right: 1rem;
		}
	}

	.code {
		display: flex;
		position: absolute;
		right: 2rem;
		top: 6rem;

		img {
			width: 11.063rem;
			height: 11.063rem;
		}

		&>div {
			display: flex;
			flex-direction: column;
			text-align: center;
			margin-right: 3.2rem;
		}
	}
}

.layout-nav-drawer-modal {
	backdrop-filter: blur(2px);
}

@media (max-width: 991px) {
	.layout-nav-drawer.el-drawer {
		.el-drawer__header {
			padding: 0;
		}
	}

	.layout-nav-drawer__head {
		padding: 0.75rem 0.85rem 0.75rem 1rem;
	}

	.layout-nav-drawer__title {
		font-size: 1rem;
	}

	.layout-mobile-nav {
		padding: 0.25rem 0 0.35rem;
	}

	.layout-mobile-nav__item {
		padding: 0.65rem 1rem;
		font-size: 0.95rem;
	}

	.layout-footer-inner {
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	.footerDiv {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
		padding-top: 1.5rem;
		align-items: center;
		text-align: center;
		font-size: 0.95rem;
	}

	.footer-logo {
		width: 11rem;
		max-width: 62vw;
	}

	.footer-address {
		text-align: left;
		width: 100%;
		max-width: 28rem;
		margin: 0 auto;
		padding-top: 0.75rem;
		line-height: 1.75rem;
		font-size: 0.9rem;
		text-align: center;
	}

	.footer .links {
		margin-left: 0;
		padding-top: 0.75rem;
		text-align: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 0.25rem 0;
		font-size: 0.95rem;
	}

	.footer .links li {
		padding: 0 0.75rem;
		height: auto;
		line-height: 1.4;
	}

	.footer-copy {
		padding-top: 0.75rem;
		padding-bottom: 1.25rem;
		font-size: 0.75rem;
		line-height: 1.55rem;
		text-align: center;
		word-break: break-word;
		max-width: 100%;
	}

	.phone {
		position: relative;
		top: 0;
		right: auto;
		width: 100%;
		height: auto;
		box-sizing: border-box;
		padding: 1.25rem 1rem 1.5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1.25rem;
	}

	.phone .mobile {
		margin: 0;
		font-size: 1rem;
		line-height: 1.65rem;
		align-items: center;
		text-align: left;
	}

	.phone .mobile img {
		width: 3.25rem;
		height: 3.25rem;
		margin-right: 0.75rem;
		flex-shrink: 0;
	}

	.footer-hotline-num {
		font-size: 1.35rem;
		line-height: 1.35;
	}

	.phone .code {
		position: static;
		right: auto;
		top: auto;
	}

	.phone .code > div {
		margin-right: 0;
		align-items: center;
	}

	.phone .code img {
		width: 7.5rem;
		height: 7.5rem;
		margin: 0 auto 0.35rem;
	}
}
</style>
